import * as client from 'filestack-js'

import settings from 'app/settings'

import { FileUploadStrategy } from './types'

export class InMemoryFileUploadStrategy implements FileUploadStrategy {
    async upload(file: File, onProgress: (progress: number) => void) {
        // Simulate file upload with progress
        const totalChunks = 10
        let uploadedChunks = 0

        // Simulate chunk upload with delays
        for (let i = 0; i < totalChunks; i++) {
            // Simulate network delay (100-300ms per chunk)
            await new Promise((resolve) => setTimeout(resolve, Math.random() * 200 + 100))

            // Update progress for this specific file
            uploadedChunks++
            const progress = (uploadedChunks / totalChunks) * 100
            onProgress(progress)
        }

        // Simulate server processing delay
        await new Promise((resolve) => setTimeout(resolve, 500))

        return Promise.resolve({
            ...file,
            url: 'https://example.com/image.jpg',
        })
    }
}

export class FilestackFileUploadStrategy implements FileUploadStrategy {
    protected filestackClient: client.Client

    constructor(protected storagePath?: string) {
        this.filestackClient = client.init(settings.FILESTACK.key, {
            cname: settings.FILESTACK.cname,
        })
    }

    async upload(file: File, onProgress: (progress: number) => void) {
        const path = this.storagePath

        const response = await this.filestackClient.upload(
            file,
            {
                onProgress: (event) => {
                    onProgress(event.totalPercent)
                },
            },
            {
                location: settings.FILESTACK.location,
                path,
            }
        )

        return Promise.resolve({
            type: file.type,
            name: file.name,
            size: file.size,
            lastModified: file.lastModified,
            url: response.url,
        })
    }
}
